import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/views/Home/index.vue'
import querydetail from '@/views/Home/querydetail.vue'
import query from '@/views/Home/query.vue'
import ypscan from '@/views/Home/ypscan.vue'
import tzggdetail from '@/views/Home/tzggdetail.vue'
import bannerdetail from '@/views/Home/bannerdetail.vue'
import xd from '@/views/Home/xd.vue'
import login from '@/views/Home/login.vue'
import addr from '@/views/Home/addr.vue'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home,
      meta: {
        title: '首页'
      }
    },{
      path: '/query',
      name: 'query',
      component: query,
      meta: {
        title: '气瓶详情'
      }
    },{
      path: '/querydetail',
      name: 'querydetail',
      component: querydetail,
      meta: {
        title: '气瓶详情'
      }
    },{
      path: '/ypscan',
      name: 'ypscan',
      component: ypscan,
      meta: {
        title: '气瓶扫码'
      }
    },{
      path: '/tzggdetail',
      name: 'tzggdetail',
      component: tzggdetail,
      meta: {
        title: '通知公告'
      }
    },{
      path: '/bannerdetail',
      name: 'bannerdetail',
      component: bannerdetail,
      meta: {
        title: '通知公告'
      }
    },{
      path: '/xd',
      name: 'xd',
      component: xd,
      meta: {
        title: '下单',
        // keepAlive: true // 需要缓存
      }
    },{
      path: '/login',
      name: 'login',
      component: login,
      meta: {
        title: '登录'
      }
    },{
      path: '/addr',
      name: 'addr',
      component: addr,
      meta: {
        title: '选择地址',
        // keepAlive: true // 需要缓存
      }
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js